<template>
  <div class="page duty">
    <p v-if="showDutyLowWarn" class="warn-tip">
      建言采纳率偏低，请督促跟进办理与反馈
    </p>

    <div class="kpi-row">
      <div class="kpi" @click="openTotalList">
        <div class="kpi__left">
          <span class="kpi__icon-wrap"><i class="ri-chat-quote-fill kpi__icon" aria-hidden="true" /></span>
          <span class="kpi__label">年度建言总数</span>
        </div>
        <b>{{ kpiInt("total") }}<em>条</em></b>
      </div>
      <div class="kpi" @click="openAdoptedList">
        <div class="kpi__left">
          <span class="kpi__icon-wrap"><i class="ri-checkbox-circle-fill kpi__icon" aria-hidden="true" /></span>
          <span class="kpi__label">已采纳数</span>
        </div>
        <b>{{ kpiInt("adopted") }}<em>条</em></b>
      </div>
      <div class="kpi kpi--rate" @click="openRateDetail">
        <div class="kpi__left">
          <span class="kpi__icon-wrap"><i class="ri-pie-chart-fill kpi__icon" aria-hidden="true" /></span>
          <span class="kpi__label">采纳率</span>
        </div>
        <div class="rate-ring" :style="rateRingStyle">
          <strong>{{ kpiInt("rate") }}%</strong>
        </div>
      </div>
      <div class="kpi" @click="openRecommend">
        <div class="kpi__left">
          <span class="kpi__icon-wrap"><i class="ri-user-star-fill kpi__icon" aria-hidden="true" /></span>
          <span class="kpi__label">年度推荐代表数</span>
        </div>
        <b>{{ kpiInt("recommend") }}<em>人</em></b>
      </div>
    </div>

    <div class="cols">
      <div class="col col--left">
        <section class="panel panel--chart">
          <h3>建言分类统计</h3>
          <div ref="catChart" class="chart"></div>
        </section>
        <section class="panel panel--chart">
          <h3>月度建言趋势</h3>
          <div ref="trendChart" class="chart"></div>
        </section>
      </div>

      <div class="col col--right">
        <section class="panel panel--scroll">
          <h3>优秀建言</h3>
          <div
            v-if="excellent.length"
            class="scroll-box"
            @mouseenter="pauseExcellentSwiper"
            @mouseleave="resumeExcellentSwiper"
          >
            <swiper
              :key="excellentSwiperKey"
              ref="excellentSwiper"
              class="excellent-swiper"
              :options="excellentSwiperOption"
            >
              <swiper-slide v-for="(it, i) in excellent" :key="i">
                <button
                  type="button"
                  class="scroll-item"
                  :class="{ gold: isGoldItem(it) }"
                  @click="openSuggestion(it)"
                >
                  <div class="scroll-item__avatar" :style="avatarStyle(it)">
                    <span v-if="!avatarUrl(it)">{{
                      (it.author || "会").slice(0, 1)
                    }}</span>
                  </div>
                  <div class="scroll-item__body">
                    <div
                      class="scroll-item__title"
                      :class="{ gold: isGoldItem(it) }"
                    >
                      <i v-if="isGoldItem(it)" class="scroll-item__star" aria-hidden="true">★</i>
                      <span class="scroll-item__title-text">{{ it.title }}</span>
                      <em v-if="highlightText(it)" class="scroll-item__hl">{{
                        highlightText(it)
                      }}</em>
                    </div>
                    <div class="scroll-item__sub">
                      <span class="scroll-item__name">
                        <span class="scroll-item__name-text">{{
                          it.author || "会员"
                        }}</span>
                        <span
                          v-if="isNpc(it)"
                          class="reps__role reps__role--npc"
                          >人大</span
                        >
                        <span
                          v-if="isCppcc(it)"
                          class="reps__role reps__role--cppcc"
                          >政协</span
                        >
                      </span>
                      <span v-if="personLine(it)" class="scroll-item__unit">{{
                        personLine(it)
                      }}</span>
                    </div>
                  </div>
                  <div class="scroll-item__right">
                    <div v-if="statusTags(it).length" class="scroll-item__tags">
                      <em
                        v-for="(tag, ti) in statusTags(it)"
                        :key="ti"
                        :class="tagClass(tag)"
                        >{{ tag }}</em
                      >
                    </div>
                    <span v-if="it.time" class="scroll-item__time">{{
                      it.time
                    }}</span>
                  </div>
                </button>
              </swiper-slide>
            </swiper>
          </div>
          <p v-else class="empty">暂无重点建言</p>
        </section>

        <section class="panel panel--cases">
          <h3>采纳案例墙</h3>
          <div ref="photoWall" class="photo-wall" :style="photoWallStyle">
            <button
              v-for="(it, i) in casePhotos"
              :key="'case-photo-' + i"
              type="button"
              class="photo-card"
              @click="openLightbox(casePhotos, i)"
            >
              <div
                class="photo-card__img"
                :style="
                  it.coverUrl
                    ? { backgroundImage: 'url(' + absUrl(it.coverUrl) + ')' }
                    : {}
                "
              />
              <span v-if="it.time" class="photo-card__date">{{ it.time }}</span>
              <span class="photo-card__title">{{ casePhotoTitle(it) }}</span>
            </button>
            <p v-if="!casePhotos.length" class="empty">暂无采纳照片</p>
          </div>
        </section>
      </div>
    </div>

    <div v-if="lightbox.open" class="lb" @click.self="closeLightbox">
      <button type="button" class="lb__nav lb__prev" @click="lightboxPrev">
        ‹
      </button>
      <div class="lb__body">
        <img
          v-if="lbItem.coverUrl"
          :src="absUrl(lbItem.coverUrl)"
          :alt="lbItem.title"
        />
        <div v-else class="lb__placeholder">{{ lbItem.title }}</div>
        <p>{{ lbItem.title }}</p>
      </div>
      <button type="button" class="lb__nav lb__next" @click="lightboxNext">
        ›
      </button>
      <button type="button" class="lb__close" @click="closeLightbox">
        ×
      </button>
    </div>
  </div>
</template>

<script>
import { PieChart, BarChart } from "@/plugins/echarts_bank/index";
import branchQuery from "@/utils/branchQuery";
import { absMediaUrl, toDetailItem, profileAvatarUrl } from "@/utils/mediaUrl";
import { isSameJson } from "@/utils/stableData";
import dashPage from "@/mixins/dashPage";

const CAT_COLORS = [
  "#3d8bff",
  "#36d7b7",
  "#f5c542",
  "#9b7bff",
  "#ff8a3d",
  "#a6bfff"
];

export default {
  name: "DashDuty",
  mixins: [branchQuery, dashPage],
  data() {
    return {
      payload: {},
      pie: null,
      bar: null,
      photoRowPx: 0,
      catsSig: null,
      trendSig: null
    };
  },
  computed: {
    photoWallStyle() {
      if (!this.photoRowPx) return null;
      return { "--photo-row-h": this.photoRowPx + "px" };
    },
    kpis() {
      return this.payload.kpis || {};
    },
    showDutyLowWarn() {
      return !this.inspectMode && Number(this.kpis.rate) < 30;
    },
    rateRingStyle() {
      const r = Number(this.kpis.rate) || 0;
      const c = this.dutyRateColor(r);
      return {
        background: `conic-gradient(${c} 0 ${r}%, rgba(255,255,255,0.12) ${r}% 100%)`
      };
    },
    items() {
      const list = this.payload.items || [];
      if (!this.inspectMode) return list;
      return list.filter(this.isAdopted);
    },
    excellent() {
      const list = this.payload.excellent || [];
      if (list.length) return list;
      // 兜底：重点 + 本年度 + 已采纳
      return this.yearItems(this.payload.items || []).filter(
        x => x && (x.isFeatured || x.IsFeatured) && this.isAdopted(x)
      );
    },
    /** 一屏约 6 条；多于 6 条才纵向无缝轮播，每次滚 1 条 */
    excellentCanLoop() {
      return this.excellent.length > 6;
    },
    excellentSwiperKey() {
      const list = this.excellent;
      const head = list
        .slice(0, 3)
        .map(it => `${it.title || ""}|${it.time || ""}|${it.author || ""}`)
        .join(";");
      return `excellent-${list.length}-${head}`;
    },
    excellentSwiperOption() {
      const canLoop = this.excellentCanLoop;
      return {
        direction: "vertical",
        slidesPerView: 6,
        spaceBetween: 6,
        loop: canLoop,
        loopedSlides: canLoop ? this.excellent.length : undefined,
        speed: 500,
        autoplay: canLoop
          ? { delay: 2000, disableOnInteraction: false }
          : false,
        allowTouchMove: true,
        observer: true,
        observeParents: true
      };
    },
    cases() {
      const list = this.payload.cases || [];
      if (list.length) return list;
      // 兜底：本年度已采纳 + 重点 + 有照片
      return this.yearItems(this.payload.items || []).filter(
        x =>
          this.isAdopted(x) &&
          (x.isFeatured || x.IsFeatured) &&
          this.suggestionPhotoUrls(x).length
      );
    },
    /** 一张照片一格上墙；同条建言多图则多格 */
    casePhotos() {
      const out = [];
      (this.cases || []).forEach(it => {
        this.suggestionPhotoUrls(it).forEach(url => {
          out.push({
            title: (it && it.title) || "",
            coverUrl: url,
            time: (it && (it.time || it.Time)) || ""
          });
        });
      });
      return out;
    },
    lbItem() {
      return this.lightbox.list[this.lightbox.index] || {};
    },
    categories() {
      return this.payload.categories || [];
    }
  },
  watch: {
    branchQuery: {
      deep: true,
      handler() {
        this.load();
      }
    },
    payload() {
      this.redrawIfChanged("catsSig", this.payload.categories || [], () => {
        this.$nextTick(() => {
          this.renderCats();
          this.updatePhotoRowHeight();
        });
      });
      this.redrawIfChanged("trendSig", this.payload.trend || [], () => {
        this.$nextTick(() => this.renderTrend());
      });
      const k = this.payload.kpis || {};
      this.syncRollKpis({
        total: k.total || 0,
        adopted: k.adopted || 0,
        rate: k.rate || 0,
        recommend: k.recommend || 0
      });
    }
  },
  mounted() {
    this.initCharts();
    this.load();
    this.startPageRefresh();
    this.$nextTick(() => this.bindPhotoWallResize());
  },
  beforeDestroy() {
    if (this.pie) this.pie.destroy();
    if (this.bar) this.bar.destroy();
    this.unbindPhotoWallResize();
  },
  methods: {
    bindPhotoWallResize() {
      this.unbindPhotoWallResize();
      const el = this.$refs.photoWall;
      if (!el || typeof ResizeObserver === "undefined") {
        this.updatePhotoRowHeight();
        return;
      }
      this._photoWallRo = new ResizeObserver(() => this.updatePhotoRowHeight());
      this._photoWallRo.observe(el);
      this.updatePhotoRowHeight();
    },
    unbindPhotoWallResize() {
      if (this._photoWallRo) {
        this._photoWallRo.disconnect();
        this._photoWallRo = null;
      }
    },
    updatePhotoRowHeight() {
      const el = this.$refs.photoWall;
      if (!el) return;
      const styles = window.getComputedStyle(el);
      const gap = parseFloat(styles.rowGap || styles.gap) || 8;
      const h = el.clientHeight;
      if (h <= 0) return;
      // 可视区域刚好 3 行
      this.photoRowPx = Math.max(72, Math.floor((h - gap * 2) / 3));
    },
    pauseExcellentSwiper() {
      const s = this.$refs.excellentSwiper && this.$refs.excellentSwiper.swiper;
      if (s && s.autoplay) s.autoplay.stop();
    },
    resumeExcellentSwiper() {
      if (!this.excellentCanLoop) return;
      const s = this.$refs.excellentSwiper && this.$refs.excellentSwiper.swiper;
      if (s && s.autoplay) s.autoplay.start();
    },
    isAdopted(x) {
      const s = ((x && (x.status || x.Status)) || "").trim();
      if (!s || s === "办理中" || s.indexOf("待") >= 0) return false;
      if (s === "已采纳") return true;
      // 兼容旧数据：曾把成果标签写在 status
      return (
        s === "已被区统战部采纳" ||
        s === "获区领导批示" ||
        s === "已落地实施" ||
        s.indexOf("采纳") >= 0 ||
        s.indexOf("批示") >= 0 ||
        s.indexOf("落地") >= 0
      );
    },
    statusTags(it) {
      if (it && Array.isArray(it.statusTags) && it.statusTags.length) {
        return it.statusTags;
      }
      // 兼容：接口未返回 tags 时，仅已采纳给默认展示标签，不把流程状态当标签
      const s = ((it && (it.status || it.Status)) || "").trim();
      if (s === "已采纳") return ["已被区统战部采纳"];
      if (s === "已落地实施" || s.indexOf("落地") >= 0) {
        return ["已被区统战部采纳", "已落地实施"];
      }
      if (s === "获区领导批示" || s.indexOf("批示") >= 0) {
        return ["已被区统战部采纳", "获区领导批示"];
      }
      if (s === "已被区统战部采纳") return ["已被区统战部采纳"];
      return [];
    },
    highlightText(it) {
      return ((it && (it.highlight || it.Highlight)) || "").trim();
    },
    isGoldItem(it) {
      if (it && (it.isHighlight || it.IsHighlight)) return true;
      if (this.highlightText(it)) return true;
      const tags = this.statusTags(it);
      return tags.some(t => String(t).indexOf("批示") >= 0 || String(t).indexOf("落地") >= 0);
    },
    avatarUrl(it) {
      // 建言封面不是头像，只用会员档案头像
      return profileAvatarUrl(it);
    },
    avatarStyle(it) {
      const url = this.avatarUrl(it);
      return url
        ? { backgroundImage: `url(${url})` }
        : { background: "linear-gradient(135deg,#1a4a8a,#0d6e6a)" };
    },
    personLine(it) {
      const unit = (it && (it.unit || it.Unit)) || "";
      const pos = (it && (it.position || it.Position || it.titleJob)) || "";
      return [unit, pos].filter(Boolean).join(" / ");
    },
    personTitle(it) {
      return String(
        (it && (it.position || it.Position || it.titleJob)) || ""
      );
    },
    isNpc(it) {
      if (it && (it.isNpc || it.IsNpc)) return true;
      return this.personTitle(it).indexOf("人大") >= 0;
    },
    isCppcc(it) {
      if (it && (it.isCppcc || it.IsCppcc)) return true;
      return this.personTitle(it).indexOf("政协") >= 0;
    },
    tagClass(tag) {
      const s = String(tag || "");
      if (s.indexOf("落地") >= 0) return "tag--land";
      if (s.indexOf("批示") >= 0) return "tag--pi";
      return "tag--adopt";
    },
    suggestionThumbs(it) {
      const raw = (it && (it.thumbs || it.Thumbs)) || [];
      return Array.isArray(raw)
        ? raw
            .map(t => {
              if (!t) return null;
              if (typeof t === "string") return { coverUrl: t };
              return {
                coverUrl: t.coverUrl || t.url || t.CoverUrl || ""
              };
            })
            .filter(t => t && t.coverUrl)
        : [];
    },
    /** 封面 + 批示/落地图去重合并（专报文案仍用 suggestionThumbs 作批示图） */
    suggestionPhotoUrls(it) {
      const urls = [];
      const seen = {};
      const add = u => {
        const s = String(u || "").trim();
        if (!s || seen[s]) return;
        seen[s] = true;
        urls.push(s);
      };
      add((it && (it.coverUrl || it.CoverUrl)) || "");
      this.suggestionThumbs(it).forEach(t => add(t.coverUrl || t.url));
      return urls;
    },
    casePhotoTitle(it) {
      const t = String((it && it.title) || "").trim();
      const max = 12;
      if (t.length <= max) return t;
      return t.slice(0, max) + "…";
    },
    suggestionBody(it) {
      if (!it) return "";
      const v = it.content != null ? it.content : it.Content;
      return typeof v === "string" ? v.trim() : "";
    },
    suggestionReply(it) {
      if (!it) return "";
      const v = it.reply != null ? it.reply : it.Reply != null ? it.Reply : it.Summary;
      return typeof v === "string" ? v.trim() : "";
    },
    buildReportContent(it) {
      const person = [
        it.author || "会员",
        this.personLine(it)
      ]
        .filter(Boolean)
        .join(" · ");
      const body = this.suggestionBody(it);
      const reply = this.suggestionReply(it);
      const lines = [
        "《建言专报》",
        `建言标题：${it.title || ""}`,
        `建言人：${person}`,
        it.time ? `采纳时间：${it.time}` : null,
        it.status ? `办理状态：${it.status}` : null,
        "",
        "一、建言全文",
        body || "（暂无正文）",
        "",
        "二、回复内容",
        reply || "（暂无回复）"
      ];
      return lines.filter(x => x !== null && x !== undefined).join("\n");
    },
    dutyRateColor(rate) {
      const r = Number(rate) || 0;
      if (r >= 50) return "#36d7b7";
      if (r >= 30) return "#3d8bff";
      return this.inspectMode ? "#36d7b7" : "#ff8a3d";
    },
    absUrl: absMediaUrl,
    initCharts() {
      const fs = this.commonFont;
      const self = this;
      this.pie = new PieChart({
        ele: this.$refs.catChart,
        fontSize: fs,
        palletColors: CAT_COLORS,
        legend: {
          show: true,
          orient: "vertical",
          left: "55%",
          top: "middle",
          textStyle: { color: "#cfe3ff", fontSize: Math.max(11, fs - 1) },
          formatter(name) {
            const row = self.categories.find(x => x.name === name);
            if (!row) return name;
            const total =
              self.categories.reduce((s, x) => s + (Number(x.value) || 0), 0) ||
              1;
            const pct = Math.round((100 * (Number(row.value) || 0)) / total);
            return `${name}  ${pct}%`;
          }
        },
        tooltip: {
          show: true,
          trigger: "item",
          formatter(res) {
            return `${res.name}：${res.value} 条，占比 ${Math.round(
              res.percent || 0
            )}%`;
          }
        },
        series: {
          name: "建言分类",
          center: ["28%", "50%"],
          radius: ["40%", "66%"],
          label: { show: false },
          labelLine: { show: false }
        }
      });
      this.bar = new BarChart({
        ele: this.$refs.trendChart,
        fontSize: fs,
        palletColors: [["#00c3ff", "#1a6dff"], "#f5c542"],
        legend: { show: true, top: 0 },
        mAxis: "xAxis",
        vAxis: "yAxis",
        grid: { top: 2.4 * fs, right: fs, bottom: 0.5 * fs, left: 0.5 * fs },
        series: [
          {
            type: "bar",
            name: "提交",
            barWidth: "32%",
            label: {
              show: true,
              position: "top",
              fontSize: Math.max(10, fs - 2),
              color: "#e8f4ff"
            }
          },
          {
            type: "bar",
            name: "采纳",
            barWidth: "32%",
            label: {
              show: true,
              position: "top",
              fontSize: Math.max(10, fs - 2),
              color: "#f5c542"
            }
          }
        ]
      });
    },
    async load() {
      const res = await this.$api("screen", "duty", this.branchQuery);
      if (res && res.code === 0) {
        if (isSameJson(this.payload, res)) return;
        this.payload = res;
      }
    },
    renderCats() {
      if (!this.pie) return;
      const data = this.categories.map(x => ({
        name: x.name || "其他",
        value: Number(x.value) || 0
      }));
      this.pie
        .setData(data.length ? data : [{ name: "暂无", value: 1 }])
        .draw();
      this.bindPieEvents();
    },
    bindPieEvents() {
      const chart = this.pie && this.pie._chart;
      if (!chart) return;
      chart.off("click");
      chart.on("click", params => {
        if (!params || params.componentType !== "series") return;
        if (!params.name || params.name === "暂无") return;
        this.openCategory(params.name);
      });
    },
    renderTrend() {
      if (!this.bar) return;
      const trend = this.payload.trend || [];
      const submit = trend.map(t => ({
        name: t.name,
        value: Number(t.value) || 0
      }));
      const adopted = trend.map(t => ({
        name: t.name,
        value: Number(t.adopted) || 0
      }));
      const empty = [{ name: "-", value: 0 }];
      this.bar
        .setData([
          submit.length ? submit : empty,
          adopted.length ? adopted : empty
        ])
        .draw();
      this.bindTrendEvents();
    },
    bindTrendEvents() {
      const chart = this.bar && this.bar._chart;
      if (!chart) return;
      chart.off("click");
      chart.on("click", params => {
        if (!params || params.componentType !== "series") return;
        const trend = this.payload.trend || [];
        const row = trend[params.dataIndex];
        if (!row) return;
        this.openMonth(row);
      });
    },
    mapItems(list) {
      return (list || []).map(it =>
        toDetailItem({
          title: it.title,
          content: it.content,
          author: it.author,
          time: it.time,
          status: it.status,
          category: it.category,
          coverUrl: it.coverUrl,
          thumbs: this.suggestionThumbs(it),
          reply: it.reply,
          unit: it.unit,
          position: it.position
        })
      );
    },
    yearOf(it) {
      const t = (it && (it.time || it.Time)) || "";
      const y = Number(String(t).slice(0, 4));
      return Number.isFinite(y) ? y : 0;
    },
    yearItems(list) {
      const year = Number(this.kpis.year) || new Date().getFullYear();
      return (list || []).filter(x => this.yearOf(x) === year);
    },
    openTotalList() {
      const list = this.yearItems(this.items);
      this.openDrawer({
        title: "年度建言列表",
        summary: [
          `${this.kpis.year || new Date().getFullYear()} 年`,
          `年度建言总数：${this.kpis.total || 0} 条`
        ],
        items: this.mapItems(list),
        list: list.map(
          x =>
            `${x.time || ""} ${x.title}${x.status ? `（${x.status}）` : ""}`
        )
      });
    },
    openAdoptedList() {
      const list = this.yearItems(this.payload.items || []).filter(this.isAdopted);
      this.openDrawer({
        title: "已采纳建言",
        summary: [
          `${this.kpis.year || new Date().getFullYear()} 年`,
          `已采纳：${this.kpis.adopted || 0} 条`
        ],
        items: this.mapItems(list),
        list: list.map(x => `${x.time || ""} ${x.title}`)
      });
    },
    openRateDetail() {
      const cats = this.categories;
      const year = Number(this.kpis.year) || new Date().getFullYear();
      const yearList = this.yearItems(this.payload.items || []);
      const total =
        cats.reduce((s, x) => s + (Number(x.value) || 0), 0) ||
        Number(this.kpis.total) ||
        1;
      const items = cats.map(c => {
        const catItems = yearList.filter(
          x => (x.category || "其他") === c.name
        );
        const count = catItems.length || Number(c.value) || 0;
        const ad = catItems.filter(this.isAdopted).length;
        const rate = count === 0 ? 0 : Math.round((100 * ad) / count);
        const share = Math.round((100 * (Number(c.value) || count)) / total);
        let level = "偏低";
        if (count === 0) level = "无建言";
        else if (rate >= 80) level = "达标";
        else if (rate >= 50) level = "关注";
        return toDetailItem({
          title: c.name || "其他",
          category: `共 ${count} 条`,
          status: level,
          time: `占总量 ${share}%`,
          content: `采纳率 ${rate}% · 已采纳 ${ad} 条 · 未采纳 ${Math.max(
            0,
            count - ad
          )} 条`
        });
      });
      this.openDrawer({
        title: "采纳率明细",
        summary: [
          `${year} 年`,
          `整体采纳率 ${this.kpis.rate || 0}%`,
          `建言总数 ${this.kpis.total || 0} 条`,
          `已采纳 ${this.kpis.adopted || 0} 条`
        ],
        items: items.length
          ? items
          : [
              toDetailItem({
                title: "暂无分类数据",
                content: `整体采纳率 ${this.kpis.rate || 0}%`
              })
            ]
      });
    },
    openRecommend() {
      const year = Number(this.kpis.year) || new Date().getFullYear();
      const list = this.payload.recommendItems || [];
      const items = list.map(r =>
        toDetailItem({
          title: r.name || "—",
          author: r.title || "",
          category: r.channel ? `渠道：${r.channel}` : "推荐渠道未填",
          time: r.time || "",
          status: "推荐",
          content: r.content || [r.title, r.channel].filter(Boolean).join(" · ")
        })
      );
      this.openDrawer({
        title: "年度推荐代表",
        summary: [
          `${year} 年`,
          `年度推荐代表数：${this.kpis.recommend || 0} 人`
        ],
        items: items.length
          ? items
          : [
              toDetailItem({
                title: "暂无推荐记录",
                content: "请在后台「建言履职 → 推荐代表」按会员录入推荐时间与渠道。"
              })
            ]
      });
    },
    openCategory(name) {
      let list = (this.payload.items || []).filter(
        x => (x.category || "其他") === name
      );
      if (this.inspectMode) list = list.filter(this.isAdopted);
      const ad = list.filter(this.isAdopted).length;
      const rate =
        list.length === 0 ? 0 : Math.round((100 * ad) / list.length);
      this.openDrawer({
        title: `${name} · 建言`,
        summary: [`共 ${list.length} 条，采纳率 ${rate}%`],
        items: this.mapItems(list),
        list: list.map(
          x => `${x.title}${x.status ? `（${x.status}）` : ""}`
        )
      });
    },
    openMonth(row) {
      const month = row.month || row.name;
      let list = (this.payload.items || []).filter(x => {
        const t = (x.time || "").slice(0, 7);
        return t === month || (row.name && (x.time || "").includes(row.name));
      });
      if (!list.length && month) {
        list = (this.payload.items || []).filter(x =>
          (x.time || "").startsWith(String(month).slice(0, 7))
        );
      }
      if (this.inspectMode) list = list.filter(this.isAdopted);
      this.openDrawer({
        title: `${month} 建言`,
        summary: [
          `提交 ${row.value || 0} 条`,
          `采纳 ${row.adopted || 0} 条`
        ],
        items: this.mapItems(list),
        list: list.length
          ? list.map(x => x.title)
          : [`该月提交 ${row.value || 0} 条`]
      });
    },
    openSuggestion(it) {
      const thumbs = this.suggestionThumbs(it);
      const detail = toDetailItem({
        title: it.title,
        category: it.category || "建言专报",
        status: it.status || "已采纳",
        statusTags: this.statusTags(it),
        highlight: this.highlightText(it),
        time: it.time,
        content: this.buildReportContent(it),
        thumbs,
        thumbsAfter: true,
        coverUrl: thumbs.length ? "" : it.coverUrl
      });
      this.openDrawer({
        title: `建言专报 · ${it.title || ""}`,
        summary: ["建言检查材料预览"],
        items: [detail]
      });
    }
  }
};
</script>

<style lang="less" scoped>
.page {
  height: 100%;
  display: flex;
  flex-direction: column;
  gap: 10 / @rem2;
  min-height: 0;
}
.warn-tip {
  margin: 0;
  padding: 6 / @rem2 12 / @rem2;
  color: #ffb070;
  background: rgba(255, 138, 61, 0.12);
  border: 1 / @rem2 solid rgba(255, 138, 61, 0.35);
  border-radius: 4 / @rem2;
  font-size: 13 / @rem2;
}
.kpi-row {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 10 / @rem2;
}
.kpi {
  min-height: 80 / @rem2;
  box-sizing: border-box;
  padding: 12 / @rem2 14 / @rem2;
  border: 1 / @rem2 solid fade(@mainColor, 35%);
  border-radius: 6 / @rem2;
  background: rgba(8, 28, 64, 0.55);
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10 / @rem2;
  cursor: pointer;
  &__left {
    display: flex;
    align-items: center;
    gap: 10 / @rem2;
    min-width: 0;
  }
  &__icon-wrap {
    position: relative;
    width: 36 / @rem2;
    height: 36 / @rem2;
    flex-shrink: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    &::before {
      content: "";
      position: absolute;
      inset: 0;
      border-radius: 50%;
      background: radial-gradient(
        circle,
        fade(@mainColor, 32%) 0%,
        fade(@mainColor, 8%) 50%,
        transparent 72%
      );
    }
  }
  &__icon {
    position: relative;
    z-index: 1;
    font-size: 20 / @rem2;
    line-height: 1;
    color: #7ae7ff;
    filter: drop-shadow(0 0 4px fade(@mainColor, 65%));
  }
  &__label {
    color: @assistColor;
    font-size: 14 / @rem2;
    white-space: nowrap;
  }
  b {
    font-size: 26 / @rem2;
    color: #fff;
    flex-shrink: 0;
    em {
      font-style: normal;
      font-size: 12 / @rem2;
      margin-left: 4 / @rem2;
      color: fade(#fff, 55%);
    }
  }
}
.kpi--rate {
  .rate-ring {
    width: 56 / @rem2;
    height: 56 / @rem2;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    position: relative;
    &::after {
      content: "";
      position: absolute;
      inset: 6 / @rem2;
      border-radius: 50%;
      background: rgba(6, 22, 52, 0.95);
    }
    strong {
      position: relative;
      z-index: 1;
      color: #fff;
      font-size: 14 / @rem2;
    }
  }
}
.cols {
  flex: 1;
  min-height: 0;
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 10 / @rem2;
}
.col {
  min-height: 0;
  display: flex;
  flex-direction: column;
  gap: 10 / @rem2;
}
.panel {
  padding: 12 / @rem2;
  border: 1 / @rem2 solid fade(@assistColor, 22%);
  border-radius: 6 / @rem2;
  background: rgba(6, 22, 52, 0.55);
  display: flex;
  flex-direction: column;
  min-height: 0;
  h3 {
    margin: 0 0 10 / @rem2;
    color: @mainColor;
    font-size: 16 / @rem2;
  }
}
.panel--chart {
  flex: 1;
}
.panel--scroll {
  flex: 1 1 0;
  overflow: hidden;
  min-height: 0;
}
.panel--cases {
  flex: 1 1 0;
  overflow: hidden;
  min-height: 0;
}
.chart {
  flex: 1;
  min-height: 150 / @rem2;
}
.scroll-box {
  flex: 1;
  min-height: 0;
  overflow: hidden;
  position: relative;
}
.excellent-swiper {
  width: 100%;
  height: 100%;
}
.scroll-box /deep/ .swiper-slide {
  box-sizing: border-box;
  height: auto;
}
.scroll-item {
  display: flex;
  align-items: center;
  gap: 10 / @rem2;
  width: 100%;
  height: 100%;
  min-width: 0;
  box-sizing: border-box;
  text-align: left;
  border: 1 / @rem2 solid fade(@assistColor, 20%);
  border-radius: 4 / @rem2;
  background: rgba(4, 18, 42, 0.5);
  color: #e8f3ff;
  padding: 8 / @rem2 10 / @rem2;
  cursor: pointer;
  transition: border-color 0.15s ease, background 0.15s ease;
  &:hover {
    border-color: fade(@mainColor, 55%);
    background: rgba(8, 32, 72, 0.72);
  }
  &.gold {
    border-color: fade(#f5c542, 40%);
    background: linear-gradient(
      90deg,
      rgba(245, 197, 66, 0.12) 0%,
      rgba(4, 18, 42, 0.45) 28%,
      rgba(4, 18, 42, 0.5) 100%
    );
  }
  &__avatar {
    width: 36 / @rem2;
    height: 36 / @rem2;
    border-radius: 50%;
    flex-shrink: 0;
    background-size: cover;
    background-position: center;
    border: 1 / @rem2 solid fade(@assistColor, 35%);
    display: flex;
    align-items: center;
    justify-content: center;
    span {
      font-size: 14 / @rem2;
      color: #cfe3ff;
      margin: 0;
    }
  }
  &__body {
    flex: 1;
    min-width: 0;
    display: flex;
    flex-direction: column;
    gap: 3 / @rem2;
  }
  &__title {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 4 / @rem2 8 / @rem2;
    font-size: 14 / @rem2;
    font-weight: 600;
    line-height: 1.35;
    color: #eef5ff;
    &.gold {
      color: #f5c542;
    }
  }
  &__star {
    flex-shrink: 0;
    font-style: normal;
    font-size: 12 / @rem2;
    color: #f5c542;
    line-height: 1;
  }
  &__title-text {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 100%;
  }
  &__hl {
    font-style: normal;
    font-size: 12 / @rem2;
    font-weight: 600;
    color: #f5c542;
    white-space: nowrap;
  }
  &__sub {
    display: flex;
    align-items: center;
    gap: 8 / @rem2;
    min-width: 0;
    font-size: 12 / @rem2;
    color: fade(#fff, 58%);
  }
  &__name {
    flex-shrink: 0;
    display: inline-flex;
    align-items: center;
    gap: 4 / @rem2;
    color: fade(#fff, 82%);
  }
  &__name-text {
    flex-shrink: 0;
  }
  &__unit {
    min-width: 0;
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    &::before {
      content: "·";
      margin-right: 8 / @rem2;
      color: fade(#fff, 35%);
    }
  }
  &__right {
    flex-shrink: 0;
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    justify-content: center;
    gap: 4 / @rem2;
    max-width: 38%;
  }
  &__tags {
    display: flex;
    flex-wrap: wrap;
    justify-content: flex-end;
    gap: 4 / @rem2;
    em {
      font-style: normal;
      font-size: 11 / @rem2;
      padding: 2 / @rem2 6 / @rem2;
      border-radius: 2 / @rem2;
      line-height: 1.35;
      white-space: nowrap;
    }
    .tag--adopt {
      color: #36d7b7;
      background: rgba(54, 215, 183, 0.1);
      border: 1 / @rem2 solid fade(#36d7b7, 38%);
    }
    .tag--pi {
      color: #f5c542;
      background: rgba(245, 197, 66, 0.1);
      border: 1 / @rem2 solid fade(#f5c542, 42%);
    }
    .tag--land {
      color: #7ae7ff;
      background: rgba(122, 231, 255, 0.1);
      border: 1 / @rem2 solid fade(#7ae7ff, 38%);
    }
  }
  &__time {
    font-size: 11 / @rem2;
    color: fade(#fff, 38%);
    font-variant-numeric: tabular-nums;
  }
}
.reps__role {
  flex-shrink: 0;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  height: 14 / @rem2;
  padding: 0 5 / @rem2;
  border-radius: 3 / @rem2;
  font-size: 10 / @rem2;
  font-weight: 700;
  font-style: normal;
  color: #fff;
  letter-spacing: 0.5px;
  &--npc {
    background: linear-gradient(135deg, #b71c1c, #e53935);
  }
  &--cppcc {
    background: linear-gradient(135deg, #0d47a1, #1e88e5);
  }
}
.photo-wall {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  grid-auto-rows: var(--photo-row-h, 120px);
  gap: 8 / @rem2;
  flex: 1;
  min-height: 0;
  overflow-x: hidden;
  overflow-y: auto;
  align-content: start;
  &::-webkit-scrollbar {
    width: 4 / @rem2;
  }
  &::-webkit-scrollbar-track {
    background: transparent;
  }
  &::-webkit-scrollbar-thumb {
    background: fade(@assistColor, 35%);
    border-radius: 4 / @rem2;
  }
  &::-webkit-scrollbar-thumb:hover {
    background: fade(@assistColor, 55%);
  }
  scrollbar-width: thin;
  scrollbar-color: fade(@assistColor, 35%) transparent;
}
.photo-card {
  position: relative;
  border: 0;
  padding: 0;
  border-radius: 4 / @rem2;
  overflow: hidden;
  cursor: pointer;
  background: rgba(0, 80, 140, 0.35);
  height: var(--photo-row-h, 120px);
  &__img {
    width: 100%;
    height: 100%;
    background: rgba(0, 100, 160, 0.4) center / cover no-repeat;
  }
  &__date {
    position: absolute;
    left: 4 / @rem2;
    top: 4 / @rem2;
    font-size: 10 / @rem2;
    padding: 1 / @rem2 4 / @rem2;
    background: rgba(0, 0, 0, 0.45);
    color: #fff;
    border-radius: 2 / @rem2;
  }
  &__title {
    position: absolute;
    left: 0;
    right: 0;
    bottom: 0;
    display: block;
    padding: 6 / @rem2 8 / @rem2;
    font-size: 11 / @rem2;
    color: #fff;
    background: linear-gradient(transparent, rgba(0, 0, 0, 0.7));
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: center;
  }
}
.empty {
  color: fade(#fff, 45%);
  margin: 0;
  font-size: 13 / @rem2;
  grid-column: 1 / -1;
}
.lb {
  position: fixed;
  inset: 0;
  z-index: 4000;
  background: rgba(0, 0, 0, 0.82);
  display: flex;
  align-items: center;
  justify-content: center;
  &__body {
    max-width: 70vw;
    text-align: center;
    img {
      max-width: 70vw;
      max-height: 75vh;
      object-fit: contain;
    }
    p {
      color: #fff;
      margin-top: 10 / @rem2;
    }
  }
  &__placeholder {
    width: 50vw;
    height: 40vh;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(20, 60, 110, 0.8);
    color: #fff;
    font-size: 20 / @rem2;
  }
  &__nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    width: 48 / @rem2;
    height: 48 / @rem2;
    border: 0;
    border-radius: 50%;
    background: rgba(255, 255, 255, 0.15);
    color: #fff;
    font-size: 28 / @rem2;
    cursor: pointer;
  }
  &__prev {
    left: 24 / @rem2;
  }
  &__next {
    right: 24 / @rem2;
  }
  &__close {
    position: absolute;
    top: 20 / @rem2;
    right: 28 / @rem2;
    border: 0;
    background: transparent;
    color: #fff;
    font-size: 32 / @rem2;
    cursor: pointer;
  }
}
</style>
